import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";

import { ALLOWED_MODULES } from "../../constants/enums";

const ReviewReply = Loadable(
	lazy(() =>
		import("./ManageReviewReply").then(({ ManageReviewReply }) => ({
			default: ManageReviewReply,
		}))
	)
);

const ReviewReplyList = Loadable(
	lazy(() =>
		import("./ReviewList").then(({ ReviewList }) => ({
			default: ReviewList,
		}))
	)
);

export const ReviewReplyRoutes = [
	{
		path: "/review",
		exact: true,
		element: (
			<AuthorizedRoute
				allowFullAccess
				moduleIds={[ALLOWED_MODULES.MANAGE_SITE]}
			>
				<ReviewReplyList />
			</AuthorizedRoute>
		),
	},
	// {
	// 	path: "/review/manage/:id",
	// 	exact: true,
	// 	element: (
	// 		<AuthorizedRoute
	// 			allowFullAccess
	// 			moduleIds={[ALLOWED_MODULES.MANAGE_SITE]}
	// 		>
	// 			<ReviewReply />
	// 		</AuthorizedRoute>
	// 	),
	// },
	{
		path: "/manage-review",
		exact: true,
		element: (
			<AuthorizedRoute
				allowFullAccess
				moduleIds={[ALLOWED_MODULES.MANAGE_SITE]}
			>
				<ReviewReply />
			</AuthorizedRoute>
		),
	},
];
